import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { invalidateQueries } from '../lib/reactQueryHelpers';
import { WsTokenTransfers } from '../types/tokenTransfer';
import { getPendingWithdrawQuery } from './usePendingWithdraw';
import { useActiveSelectedSubaccount } from './useSelectedSubaccount';
import { subaccountBalanceQuery } from './useSubaccountBalance';
import { transferQuery } from './useTransfers';
import { useTokenTransfer } from './useWebsocketStore';

export const useTransferSub = () => {
  const selectedSubaccount = useActiveSelectedSubaccount();
  const queryClient = useQueryClient();
  const currentSubaccountId = selectedSubaccount?.id;

  const handler = useCallback(
    (transfers: WsTokenTransfers) => {
      if (!currentSubaccountId) return;

      // Check if any transfer is not FEES_CLAIMED
      const relevantTransfer = transfers.data.find((transfer) => transfer.type !== 'FEES_CLAIMED');

      if (!relevantTransfer) return;

      invalidateQueries(queryClient, transferQuery({ subaccountId: currentSubaccountId }).queryKey);
      invalidateQueries(queryClient, subaccountBalanceQuery(currentSubaccountId).queryKey);

      // Check if any transfer is a withdrawal
      const hasWithdrawal = transfers.data.some((transfer) => transfer.type === 'WITHDRAW');

      if (hasWithdrawal) {
        invalidateQueries(queryClient, getPendingWithdrawQuery(currentSubaccountId).queryKey);
      }
    },
    [currentSubaccountId, queryClient]
  );

  useTokenTransfer(currentSubaccountId, handler);
};
